export default __webpack_public_path__ + "static/media/list-next.3131c855.svg";